<template>
  <div>
    <tab-bar class="tab-bar">
      <tab-bar-item path="/home">
        <img slot="item-icon" src="~@/assets/img/tabbar/home.svg" alt="啊哈哈" title="首页">
        <img slot="item-icon-active" src="~@/assets/img/tabbar/home_active.svg">
        <div slot="item-text">首页</div>
      </tab-bar-item>
      <tab-bar-item path="/category">
        <img slot="item-icon" src="~@/assets/img/tabbar/category.svg" alt="">
        <img slot="item-icon-active" src="~@/assets/img/tabbar/category_active.svg">
        <div slot="item-text">分类</div>
      </tab-bar-item>
      <tab-bar-item path="/shopcart">
        <img slot="item-icon" src="~@/assets/img/tabbar/shopcart.svg" alt="">
        <img slot="item-icon-active" src="~@/assets/img/tabbar/shopcart_active.svg">
        <div slot="item-text">购物车</div>
      </tab-bar-item>
      <tab-bar-item path="/profile">
        <img slot="item-icon" src="~@/assets/img/tabbar/profile.svg" alt="">
        <img slot="item-icon-active" src="~@/assets/img/tabbar/profile_active.svg">
        <div slot="item-text">我的</div>
      </tab-bar-item>
    </tab-bar>
  </div>
</template>

<script>
import TabBar from '../common/TabBar/TabBar.vue'
import TabBarItem from '../common/TabBar/TabBarItem.vue'
export default {
  name: '',
  data() {
    return {

    }
  },
  components: {
    TabBar,
    TabBarItem

  }
}
</script>

<style scoped>
.tab-bar {
  z-index: 1000;
}
</style>
